export default __webpack_public_path__ + "media/zurb/img/playground/figma-logo-clean-2aa3c5b2a53462248156f93978eb4d78.png";